import { lazy } from "react";

export { OPPORTUNITY_PATH } from "./opportunity-path";
export const OpportunityPage = lazy(() => import("./opportunity-page"));
